"use client";

import NavbarComponent from "./NavbarComponent";
import { Banner } from '@/components/layout/Banner'

export default function ConditionalNavbar({ bannerData = null }) {
    return (
        <>
            {bannerData?.bannerConfig && (
                <Banner
                    bannerText={bannerData.bannerText}
                    bannerCtaText={bannerData.bannerCtaText}
                    bannerCta={bannerData.bannerCta}
                />
            )}
            <NavbarComponent />
        </>
    );
}
